module.exports = __webpack_public_path__ + "static/media/selfish.738a9441.png";